import { USER_ME } from '@/config/api/api-routes';
import { http } from '@/shared/api/http';
import { getDeviceId } from '@/shared/helpers';
import type { ResultApi } from '@/shared/types/result-api';
import axios from 'axios';
import type { LoginRequest, LoginResponse } from '../models/auth-login';
import type { UserMe } from '../models/user-me';

const authInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL
});

export const requestOtp = async (username: string): Promise<LoginResponse> => {
  const response = await authInstance.post<ResultApi<LoginResponse>>(
    'vpubtp/user/auth/otp-request',
    {
      phoneNumber: null,
      username: username
    },
    {
      headers: {
        deviceId: getDeviceId()
      }
    }
  );
  return response.data.data!;
};

export const loginApi = async (loginData: LoginRequest): Promise<LoginResponse> => {
  const response = await authInstance.post<ResultApi<LoginResponse>>(
    'vpubtp/user/auth/login-with-otp',
    { userName: loginData.username, otp: loginData.otp },
    {
      headers: {
        deviceId: getDeviceId()
      }
    }
  );
  return response.data.data!;
};

export const authRefreshToken = async (accessToken: string, refreshToken: string): Promise<LoginResponse> => {
  const response = await authInstance.post<ResultApi<LoginResponse>>(
    'vpubtp/user/auth/refresh-token',
    { accessToken, refreshToken, dnnToken: '' },
    {
      headers: {
        deviceId: getDeviceId()
      }
    }
  );
  return response.data.data!;
};

export const getCurrentUser = async (token: string): Promise<UserMe> => {
  const response = await http.get<ResultApi<UserMe>>(
    USER_ME,
    token
      ? {
          headers: { Orion: `Rigel ${token}` }
        }
      : {}
  );
  return response.data.data!;
};
